// extracted by mini-css-extract-plugin
export default {"box":"Ga8Ne0nx5cSyGF5s9Azx","infoBox":"UMLZ48hk4cnfwRkarYMp"};